import { Device } from '@twilio/voice-sdk';

export const createVoiceSdkDevice = async ({ getJWT }: { getJWT: () => Promise<string> }): Promise<Device> => {
  const token = await getJWT();
  const device = new Device(token, {
    disableAudioContextSounds: true,
    logLevel: 'info',
    tokenRefreshMs: 30 * 1000,
  });

  device.on(Device.EventName.TokenWillExpire, async () => {
    console.log('Token will expire');
    return getJWT().then((newToken) => device.updateToken(newToken));
  });
  //device.on('tokenDidExpire', () => getJWT().then((newToken) => newToken));
  device.on(Device.EventName.Registered, () =>
    console.log({
      severity: 'success',
      summary: 'Calls Online',
      detail: 'Your device is ready and online to start receiving voice calls.',
    }),
  );
  device.on(Device.EventName.Unregistered, () => {
    console.log({
      severity: 'info',
      summary: 'Calls Offline',
      detail:
        'You will no longer receive calls on this device. If this is a mistake please check your internet, and if the problem persists restart your browser.',
    });
  });

  return device;
};
